<template>
<div class="chapter">
<div class="inner_page">
<h1 class="fm-title" id="fm-7"><a id="page_xxvi"><em>Epigraphic Conventions</em></a></h1><a id="page_xxvi">
</a><p class="para"><a id="page_xxvi"><span class="dropcap">T</span>hroughout this book, the reader will notice numerous symbols, called <em class="italic">sigla</em>, associated with the Greek and Latin inscriptions that I cite, especially in “</a><span href="#/019_Appendix01#bm-2" title="Link target outside of Sample">Appendix 1: Inscriptions</span>.” For this reason, this section provides a short explanation for each <em class="italic">siglum</em> (the singular of <em class="italic">sigla</em>) that I use:</p>
<table class="table1">
<tbody>
<tr>
<td class="wid15">
<p class="t-left">[ ]</p></td>
<td class="wid80">
<p class="t-left">A letter or letters within brackets are not present in the epigraph but are ones that an editor has restored.</p></td>
</tr>
<tr>
<td class="wid15">
<p class="t-left">( )</p></td>
<td class="wid80">
<p class="t-left">Letters within parentheses are part of the abbreviated form of a word and were omitted by the stonecutter to save space.</p></td>
</tr>
<tr>
<td class="wid15">
<p class="t-left"><span class="charis">˂</span> <span class="charis">˃</span></p></td>
<td class="wid80">
<p class="t-left">Letters within angular brackets have been omitted or substituted by the stonecutter.</p></td>
</tr>
<tr>
<td class="wid15">
<p class="t-left">[[ ]]</p></td>
<td class="wid80">
<p class="t-left">Letters within double brackets have been erased in antiquity.</p></td>
</tr>
<tr>
<td class="wid15">
<p class="t-left">{ }</p></td>
<td class="wid80">
<p class="t-left">Letters within curved brackets are superfluous and have been inscribed by the stonecutter by mistake.</p></td>
</tr>
<tr>
<td class="wid15">
<p class="t-left">[…]</p></td>
<td class="wid80">
<p class="t-left">Brackets with dots inside represent instances in which, while letters are missing, the number of them is known.</p></td>
</tr>
<tr>
<td class="wid15">
<p class="t-left">[- - -]</p></td>
<td class="wid80">
<p class="t-left">Brackets with dashes inside represent instances in which, while the letters are missing, the number of them is unknown.</p></td>
</tr>
<tr>
<td class="wid15">
<p class="t-left"><span class="charis">α̣</span></p></td>
<td class="wid80">
<p class="t-left">A letter with a dot under it means that it is only partially preserved in the inscription.</p></td>
</tr>
<tr>
<td class="wid15">
<p class="t-left"><span class="underline">α</span></p></td>
<td class="wid80">
<p class="t-left">A letter with a line under it means that the letter is no longer visible, but an older editor of the epigraph noted its presence.</p></td>
</tr>
<tr>
<td class="wid15">
<p class="t-left"><em class="italic">vacat</em></p></td>
<td class="wid80">
<p class="t-left">This Latin verb, which means “it is empty or vacant,” indicates that the stonecutter has intentionally left a space in the epigraph in question.</p></td>
</tr>
</tbody>
</table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 012_EpigraphicConventions.vue?78e581ac